import { Injectable } from "@angular/core";
import { CanActivate, GuardResult, MaybeAsync } from "@angular/router";
import { el, mount } from "src/app/support/dom";

@Injectable()
export class MountIframePdfViewerGuard implements CanActivate {
  canActivate(): MaybeAsync<GuardResult> {
    mount(
      document.body,
      el(
        "div",
        {
          class:
            "absolute inset-0 flex justify-center p-2 -z-10 bg-slate-600/50 opacity-0"
        },
        el("iframe", {
          id: "snt-iframe-print-pdf",
          class: "border-2 rounded-md -z-10 border-slate-600",
          style: "aspect-ratio: 1 / 1.4142",
          credentialless: true
        })
      )
    );

    return true;
  }
}
